<template>
  <v-img src="@/assets/ic-arrow-up-right.svg" />
</template>
<script>
export default {
  name: 'ArrowUpRight',
};
</script>
